module.exports = __webpack_public_path__ + "img/JustynaiInsta_Final.7defa742.jpg";